import { ChangeEvent, useEffect, useRef, useState } from "react";
import { BrowseDeviceIcon } from "../components/LayoutIcons";

const BrowseDeviceField = ({
  id,
  name,
  onChange,
  value,
  className,
  style,
  errorFields,
  accept,
}: {
  onChange: (value: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  name: string;
  value: string;
  className?: string;
  style?: any;
  errorFields?: Record<string, boolean>;
  accept?: string;
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef: any = useRef();

  // Handler to remove the selected file
  const handleRemove = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      // Create a minimal synthetic event to notify parent
      const event = {
        target: inputRef.current,
      } as ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  };

  useEffect(() => {
    if (isFocused) {
      inputRef.current.focus();
    }
  }, [isFocused]);

  return (
    <>
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          cursor: "pointer",
          color: "#CECECE",
          ...(errorFields?.[name] ? { borderColor: "red" } : {}),
        }}
        onClick={() => inputRef.current?.click()}
      >
        <BrowseDeviceIcon /> Browse device
      </div>
      <input
        ref={inputRef}
        type="file"
        hidden
        id={id}
        value={value}
        name={name}
        onChange={onChange}
        // onChange={handleFileImageChange}
        accept={accept}
      />
      {inputRef.current?.files?.[0]?.name && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginTop: 5,
          }}
        >
          <div
            style={{
              fontWeight: 300,
              fontSize: 12,
              maxWidth: "40%",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {inputRef.current?.files?.[0]?.name}
          </div>
          <div
            style={{ color: "#f02d2d", cursor: "pointer" }}
            onClick={handleRemove}
          >
            remove
          </div>
        </div>
      )}
    </>
  );
};

export default BrowseDeviceField;
